
'use client';

import { firebaseConfig } from '@/firebase/config';
import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getStorage, FirebaseStorage } from 'firebase/storage';

// IMPORTANT: DO NOT MODIFY THIS FUNCTION
export function initializeFirebase(): {
    firebaseApp: FirebaseApp;
    auth: Auth;
    firestore: Firestore;
    storage: FirebaseStorage;
} {
  if (getApps().length) {
    return getSdks(getApp());
  }

  const firebaseApp = initializeApp(firebaseConfig);
  return getSdks(firebaseApp);
}

export function getSdks(firebaseApp: FirebaseApp) {
  return {
    firebaseApp,
    auth: getAuth(firebaseApp),
    firestore: getFirestore(firebaseApp),
    storage: getStorage(firebaseApp),
  };
}

// Explicit named exports to avoid conflicts
export { FirebaseProvider, useFirebase, useAuth, useFirestore, useFirebaseApp, useStorage, useMemoFirebase, useUser as useFirebaseUser } from './provider';
export type { FirebaseProviderProps, FirebaseContextState, FirebaseServicesAndUser, UserHookResult } from './provider';

// Export Firestore instance for server-side operations
const { firestore } = initializeFirebase();
export const db = firestore;

export { FirebaseClientProvider } from './client-provider';

export { useUser } from './auth/use-user';
export type { UserAuthHookResult } from './auth/use-user';

export { useCollection } from './firestore/use-collection';
export type { UseCollectionResult, WithId } from './firestore/use-collection';

export { useDoc } from './firestore/use-doc';
export type { UseDocResult } from './firestore/use-doc';

export { setDocumentNonBlocking, addDocumentNonBlocking, updateDocumentNonBlocking, deleteDocumentNonBlocking } from './non-blocking-updates';
export { FirestorePermissionError } from './errors';
export { errorEmitter } from './error-emitter';
